import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { WidgetBanner } from './HomepageHeroWidget.style';
import { HeroWidgetImagesType } from './HeroWidgetItem.state';
import { action, makeObservable } from 'mobx';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

class HeroWidgetBannerState {
    public constructor(
        private readonly router: StarRouter,
        private readonly slug: string
    ) {
        makeObservable(this);
    }

    @action public redirectToCustomStaticPage = (): void => {
        this.router.redirectToStaticResourceHeroWidget(this.slug);
    };
}

interface HeroWidgetBannerPropsType {
    withMargin: boolean;
    banners: HeroWidgetImagesType;
    slug: string;
    content: string;
    title: string;
}

export const HeroWidgetBanner = observer(
    'HeroWidgetBanner',
    ({ withMargin, banners, slug, content }: HeroWidgetBannerPropsType): JSX.Element | null => {
        const common = useCommon();
        const starRouter = StarRouter.get(common);
        const [promoHeroWidget] = useState(() => new HeroWidgetBannerState(starRouter, slug));
        const {
            componentVariants: { sportsbookVariant },
        } = ConfigComponents.get(common).unifiedComponentConfig;

        return (
            <WidgetBanner
                withMargin={withMargin}
                banners={banners}
                variant={sportsbookVariant}
                iaContent={content !== ''}
                onClick={content === '' ? undefined : promoHeroWidget.redirectToCustomStaticPage}
                data-test='promo-banner'
            />
        );
    }
);
